const useSearchParams = () => {
    function getSearchParams (key) {
        const regex = /\[.*?\]/; // Regular expression to match square brackets and their contents
        const url = new URL(window.location);
        if (regex.test(key)) {
            return url.searchParams.getAll(key) || [];
        }
        return url.searchParams.get(key) || "";
    }

    function createSearchParams (key = "tab", value) {
        const url = new URL(window.location);
        url.searchParams.set(key, value);
        window.history.replaceState({}, "", url);
    }

    function deleteParams (keys) {
        const url = new URL(window.location);
        const params = new URLSearchParams(url.search);

        if (typeof keys === "string") {
            // If a single key is provided, delete it
            params.delete(keys);
            url.searchParams.delete(keys);
        } else if (Array.isArray(keys)) {
            // If an array of keys is provided, delete each key
            keys.forEach(key => {
                params.delete(key);
                url.searchParams.delete(key);
            });
        }

        window.history.replaceState({}, "", url);
    }

    /**
   * It takes a string and appends it to the current URL
   * @param newUrl - The new URL to append to the current URL.
   */
    function appendUrl (newUrl, onload = false) {
        const url = new URL(window.location);
        if (onload) window.history.replaceState(
            {},
            "",
            url.origin + url.pathname + url.search
        );
        else window.history.replaceState(
            {},
            "",
            `${url.origin + url.pathname}?${newUrl}`
        );
    }

    return {
        getSearchParams,
        deleteParams,
        createSearchParams,
        appendUrl
    };
};

export default useSearchParams;
